"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, show = _a.show, className = _a.className;
        return (React.createElement("div", { style: { display: show ? "block" : "none" }, className: "text-center ".concat(className || "") },
            React.createElement("svg", { className: "spinner", width: "30px", height: "30px", viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("circle", { className: "path", fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }))));
    };
    return Spinner;
}(React.Component));
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/Spinner.js
// module id = 962
// module chunks = 0